// Commented by Akhil - Updated AdminPannel with proper sidebar icons and light theme styling
import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import { ThemeProvider } from "@emotion/react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ListItemIcon from "@mui/material/ListItemIcon";
import { customTheme } from "./them/customeThem";
import AdminNavbar from "./Navigation/AdminNavbar";
import Dashboard from "./Views/Admin";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import DemoAdmin from "./Views/DemoAdmin";
import CreateProductForm from "./componets/createProduct/CreateProductFrom";

import "./AdminPannel.css";
import ProductsTable from "./componets/Products/ProductsTable";
import OrdersTable from "./componets/Orders/OrdersTable";
import Customers from "./componets/customers/customers";
import UpdateProductForm from "./componets/updateProduct/UpdateProduct";
// Commented by Akhil - Added Footer component from homepage
import Footer from "../customer/Components/footer/Footer";

// Commented by Akhil - Importing relevant icons for each menu item
import DashboardIcon from "@mui/icons-material/Dashboard";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import GroupIcon from "@mui/icons-material/Group";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddBoxIcon from "@mui/icons-material/AddBox";

const drawerWidth = 240;

// Commented by Akhil - Menu with icon property for each item
const menu = [
  { name: "Dashboard", path: "/admin", icon: <DashboardIcon /> },
  { name: "Products", path: "/admin/products", icon: <Inventory2Icon /> },
  { name: "Customers", path: "/admin/customers", icon: <GroupIcon /> },
  { name: "Orders", path: "/admin/orders", icon: <ShoppingCartIcon /> },
  { name: "Add Product", path: "/admin/product/create", icon: <AddBoxIcon /> },
];

export default function AdminPannel() {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const [sideBarVisible, setSideBarVisible] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Commented by Akhil - Check if current path matches menu item for active styling
  const isActive = (path) => {
    if (path === "/admin") {
      return location.pathname === "/admin";
    }
    return location.pathname.startsWith(path);
  };

  const drawer = (
    <Box
      sx={{
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start", // Commented by Akhil - Changed from space-between to flex-start to position menu at top
        height: "100%",
        backgroundColor: "#ffffff",
      }}
    >
      {isLargeScreen && <Toolbar />}
      <List>
        {menu.map((item) => (
          <ListItem
            key={item.name}
            disablePadding
            onClick={() => {
              navigate(item.path);
              if (!isLargeScreen) setSideBarVisible(false);
            }}
          >
            <ListItemButton
              sx={{
                mx: 1,
                borderRadius: 2,
                mb: 0.5,
                backgroundColor: isActive(item.path) ? '#6B8E23' : 'transparent',
                color: isActive(item.path) ? '#ffffff' : '#1A1A1A',
                '&:hover': {
                  backgroundColor: isActive(item.path) ? '#5a7a1f' : '#f0f0f0',
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: isActive(item.path) ? '#ffffff' : '#6B8E23',
                  minWidth: 40,
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                primaryTypographyProps={{
                  fontWeight: isActive(item.path) ? 600 : 400,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const handleSideBarViewInMobile = () => {
    setSideBarVisible(true);
  };

  const handleCloseSideBar = () => {
    setSideBarVisible(false);
  };

  const drawerVariant = isLargeScreen ? "permanent" : "temporary";

  return (
    <ThemeProvider theme={customTheme}>
      {/* Commented by Akhil - Wrapper for full-height layout with sticky footer */}
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Box sx={{ display: `${isLargeScreen ? "flex" : "block"}`, flex: 1, backgroundColor: '#f5f5f5' }}>
          <CssBaseline />
          <AdminNavbar handleSideBarViewInMobile={handleSideBarViewInMobile} />

          <Drawer
            variant={drawerVariant}
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: drawerWidth,
                boxSizing: "border-box",
                backgroundColor: "#ffffff",
                borderRight: "1px solid #e0e0e0",
                ...(drawerVariant === "temporary" && {
                  top: 0,
                }),
              },
            }}
            open={isLargeScreen || sideBarVisible}
            onClose={handleCloseSideBar}
          >
            {drawer}
          </Drawer>
          <Box
            className="adminContainer"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              backgroundColor: '#f5f5f5',
            }}
          >
            <Toolbar />
            <Routes>
              <Route path="/" element={<Dashboard />}></Route>
              <Route path="/product/create" element={<CreateProductForm />}></Route>
              <Route path="/product/update/:productId" element={<UpdateProductForm />}></Route>
              <Route path="/products" element={<ProductsTable />}></Route>
              <Route path="/orders" element={<OrdersTable />}></Route>
              <Route path="/customers" element={<Customers />}></Route>
              <Route path="/demo" element={<DemoAdmin />}></Route>
            </Routes>
          </Box>
        </Box>
        {/* Commented by Akhil - Footer with left margin to avoid sidebar overlap on large screens */}
        <Box sx={{ ml: isLargeScreen ? `${drawerWidth}px` : 0 }}>
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
